// @flow
import { connect } from 'react-redux';
import { withProps, compose } from 'react-recompose';
import RoamingFrames from './RoamingFrames';
import { travelUsagesSelector } from '../../../../modules/Usage/selectors';
import type { StateType } from '../../../../modules/reducers';
import type { StateProps } from './RoamingFrames';

const withTravelProps = () => ({
  type: 'TRAVEL',
});

const mapStateToProps = (state: StateType): StateProps => ({
  packages: travelUsagesSelector(state),
});

export default compose(connect(mapStateToProps), withProps(withTravelProps))(RoamingFrames);
